<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:10px">
			<el-breadcrumb-item>小程序图片</el-breadcrumb-item>
		</el-breadcrumb>
		<el-card class="box-card" v-loading="loading" element-loading-text="加载中,请稍后"
				 element-loading-background="rgba(0, 0, 0, 0.8)">
			<h3>首页轮播图</h3>
			<el-upload
					action="string"
					:on-preview="handlePictureCardPreview"
					:http-request='submitUpload'
					list-type="picture-card"
					:on-remove="handleRemove"
					:file-list="fileList2">
				<i class="el-icon-plus"></i>
			</el-upload>
			<div v-for="feng in fileList2" style="float:left">
				<el-select clearable v-model="feng.name"
						   @change="updateRoll(feng,1)" style="width:147px;margin :0 5px 10px 0"
						   filterable placeholder="请选择">
					<el-option v-for="item in scenicList" :key="item.area_id"
							   :label="item.area_name" :value="item.area_id"></el-option>
				</el-select>
				<br>
				<!-- <el-input  v-model="feng.number" style="width:147px;margin :0 5px 20px 0"></el-input> -->
			</div>
			<el-dialog :visible.sync="dialogVisible">
				<img width="100%" :src="dialogImageUrl" alt="">
			</el-dialog>
		</el-card>
		<el-card class="box-card" v-loading="loading2" element-loading-text="加载中,请稍后"
				 element-loading-background="rgba(0, 0, 0, 0.8)">
			<h3>券包轮播图</h3>
			<el-upload action="string" :on-preview="handlePictureCardPreview"
					   :http-request='couponUpload' list-type="picture-card" :on-remove="removeCoupon"
					   :file-list="fileList3">
				<i class="el-icon-plus"></i>
			</el-upload>
			<div v-for="v in fileList3" style="float:left">
				<el-select clearable v-model="v.name"
						   @change="updateRoll(v,2)" style="width:147px;margin :0 5px 10px 0"
						   filterable placeholder="请选择">
					<el-option v-for="item in scenicList" :key="item.area_id"
							   :label="item.area_name" :value="item.area_id"></el-option>
				</el-select>
				<br>
				<!-- <el-input  v-model="feng.number" style="width:147px;margin :0 5px 20px 0"></el-input> -->
			</div>
<!--			<el-dialog :visible.sync="dialogVisible">-->
<!--				<img :src="dialogImageUrl" alt="">-->
<!--			</el-dialog>-->
		</el-card>
		<el-card class="box-card" style="margin:20px 0 0 0 ">
			<h3>小程序首页 </h3>
			<el-upload
					style="width: 100%;"
					class="avatar-uploader"
					action="string"
					:http-request='submitUploadHomeImg'
					:show-file-list="false"
					ref='upload'>
				<img id="img-id" :src="homeImg" v-if="homeImg"
					 @contextmenu.prevent="dialogVisible=true,dialogImageUrl= homeImg"
					 class="avatar"
					 style="width:320px;height:320px;">
				<!-- <img  @contextmenu.prevent="dialogVisible=true,dialogImageUrl= homeImg" v-if="homeImg" :src="homeImg" class="avatar" style="width:120px;height:120px;border:1px solid #e8e8e8"> -->
				<i v-else class="el-icon-plus avatar-uploader-icon"
				   style="width:320px;height:320px;border:1px solid #e8e8e8;vertical-align: middle;"></i>
			</el-upload>
		</el-card>
	</div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import ElRow from "element-ui/packages/row/src/row";
import ElCol from "element-ui/packages/col/src/col";
import {mapState} from "vuex";

export default {
	data() {
		return {
			loading: false,
			loading2: false,
			scenicList: [],
			contentInfo: [],
			testList: [],
			dialogImageUrl: "",
			dialogVisible: false,
			fileList2: [],
			fileList3: [],
			slideshowList: [], //轮播图存储数组
			homeImg: "",
			homeID: "",
		};
	},
	mounted() {
		this.findSlideshow(1); //查询轮播图
		this.findSlideshow(2); //查询券包轮播图
		this.findHomePhoto(); //查询首页图
		this.findScenic();//查询景点
	},
	methods: {
		//提交轮播图片
		submitUpload(file) {
			if (!this.loading) {
				this.loading = true
				let param = new FormData(); // 创建 form 对象
				param.append("file", file.file, file.file.name); // 通过 append 向 form 对象添加数据
				let config = {
					headers: {"Content-Type": "multipart/form-data"}
				}; // 添加请求头
				this.$axios.postImageRequest("admin/putObject", param, config).then(response => {
					this.fileList2.push({
						url: response.data,
						name: "",
						ID: "",
						number: ""
					});
					this.addRoll(1);
				});
			}
		},
		couponUpload(file) {//券包
			if (!this.loading2) {
				this.loading2 = true;
				let param = new FormData(); // 创建 form 对象
				param.append("file", file.file, file.file.name); // 通过 append 向 form 对象添加数据
				let config = {
					headers: {"Content-Type": "multipart/form-data"}
				}; // 添加请求头
				this.$axios.postImageRequest("admin/putObject", param, config).then(response => {
					this.fileList3.push({
						url: response.data,
						name: "",
						ID: "",
						number: ""
					});
					this.addRoll(2);
				});
			}
		},
		//修改滚动列
		updateRoll(feng, lx) {
			var userData = qs.parse(sessionStorage.getItem("userData"));
			var that = this;

			var salesInfoData = {
				lx,
				id: feng.ID,
				pic_url: feng.url,
				area_id: feng.name,
			};
			var salesInfoParams = {
				methodUrl: "admin/upSettings",
				jsonParam: qs.stringify(salesInfoData)
			};
			this.$axios.postRequest(salesInfoParams).then(function (res) {
						//成功之后处理逻辑
						that.$message({
							message: '设置成功',
							type: 'success',
						})
						that.findSlideshow(lx);
					},
					function (res) {
						//失败之后处理逻辑
						that.$message({
							message: '设置失败',
							type: "error",
						})
						console.log("error:");
					}
			);
		},
		//查询轮播图
		findSlideshow(lx) {
			let salesInfoParams = {
				methodUrl: "admin/getSettings",
				jsonParam: qs.stringify({lx})
			};
			this.$axios.postRequest(salesInfoParams).then(res => {
						if (lx === 1) {
							this.fileList2=[];
							res.data.forEach(v => {
								this.fileList2.push({
									url: v.pic_url,
									ID: v.id,
									name: v.area_id,
								});
							})
							this.loading=false;
						} else if (lx === 2) {
							this.fileList3=[];
							res.data.forEach(v => {
								this.fileList3.push({
									url: v.pic_url,
									ID: v.id,
									name: v.area_id,
								});
							})
							this.loading2=false;
						}
					},
					function (res) {
						//失败之后处理逻辑
						console.log("error:");
					}
			);
		},
		//新增滚动列、轮播图
		addRoll(lx) {
			var that = this;
			var contentInfos = [];
			let fileList;
			lx === 1 ? fileList = this.fileList2 : fileList = this.fileList3;
			for (let i = 0; i < fileList.length; i++) {
				contentInfos.push(fileList[i].url);
			}
			var salesInfoData = {
				lx,
				pic_url: contentInfos[contentInfos.length - 1],
				area_id: "",
				sort_num: ""
			};

			var salesInfoParams = {
				methodUrl: "admin/addSettings",
				jsonParam: qs.stringify(salesInfoData)
			};
			this.$axios.postRequest(salesInfoParams).then(function (res) {
						//成功之后处理逻辑
						that.$message({
							message: "添加成功",
							type: "success"
						});
						that.findSlideshow(lx);
					},
					function (res) {
						//失败之后处理逻辑
						console.log("error:");
					}
			);
		},


		//查询滚动列
		// findRoll() {
		//   var userData = qs.parse(sessionStorage.getItem("userData"));
		//   var that = this;
		//   that.fileList2 = [];
		//   var salesInfoData = {};

		//   var salesInfoParams = {
		//     methodUrl: "admin/wxRoll",
		//     jsonParam: qs.stringify(salesInfoData)
		//   };
		//   this.$axios.postRequest(salesInfoParams).then(
		//     function(res) {
		//       //成功之后处理逻辑

		//       for (var i = 0; i < res.data.length; i++) {
		//         that.fileList2.push({
		//           url: res.data[i].scrollbar_url,
		//           name: res.data[i].product_id,
		//           ID: res.data[i].scrollbar_id
		//         });
		//       }
		//       console.log(that.dialogImageUrl);
		//     },
		//     function(res) {
		//       //失败之后处理逻辑
		//       console.log("error:");
		//     }
		//   );
		// },
		//删除滚动列、轮播图
		handleRemove(file, fileList) {
			var userData = qs.parse(sessionStorage.getItem("userData"));
			var that = this;
			var salesInfoData = {
				id: file.ID
			};
			var salesInfoParams = {
				methodUrl: "admin/delSettings",
				jsonParam: qs.stringify(salesInfoData)
			};
			this.$axios.postRequest(salesInfoParams).then(function (res) {
						that.$message({
							showClose: true,
							message: "删除成功",
							type: "success"
						});
						that.findSlideshow(1);
					},
					function (res) {
						//失败之后处理逻辑
						console.log("error:");
					}
			);
		},
		removeCoupon(file, fileList) {
			this.$axios.postRequest({
				methodUrl: "admin/delSettings",
				jsonParam: qs.stringify({id: file.ID})
			}).then(res => {
						this.$message({
							showClose: true,
							message: "删除成功",
							type: "success"
						});
						this.findSlideshow(2);
					},
					function (res) {
						//失败之后处理逻辑
						console.log("error:");
					}
			);
		},
		//提交首页图(对象存储)
		submitUploadHomeImg(file) {
			let param = new FormData(); // 创建 form 对象
			param.append("file", file.file, file.file.name); // 通过 append 向 form 对象添加数据
			let config = {
				headers: {"Content-Type": "multipart/form-data"}
			}; // 添加请求头
			this.$axios
					.postImageRequest("admin/putCenterObject", param, config)
					.then(
							response => {
								this.homeImg = response.data;
								document.getElementById('img-id').src = document.getElementById('img-id').src + "?" + Math.random();
								this.$message({
									showClose: true,
									message: "上传成功",
									type: "success"
								});
							},
							response => {
								this.$message({
									message: '上传失败',
									type: "error",
								})
							}
					);
		},
		// //提交首页图（后台）
		// addHomeImg() {
		//   var userData = qs.parse(sessionStorage.getItem("userData"));
		//   var that = this;

		//   var salesInfoData = {
		//     lx: 0,
		//     pic_url: that.homeImg,
		//     area_id: "",
		//     sort_num: ""
		//   };

		//   var salesInfoParams = {
		//     methodUrl: "admin/addSettings",
		//     jsonParam: qs.stringify(salesInfoData)
		//   };
		//   this.$axios.postRequest(salesInfoParams).then(
		//     function(res) {
		//       //成功之后处理逻辑
		//        that.findHomePhoto();
		//       that.$message({
		//         message: "添加成功",
		//         type: "success"
		//       });

		//     },
		//     function(res) {
		//       //失败之后处理逻辑
		//       console.log("error:");
		//     }
		//   );
		// },
		//查询首页图
		findHomePhoto() {
			var userData = qs.parse(sessionStorage.getItem("userData"));
			var that = this;

			var salesInfoData = {
				lx: 0
			};
			var salesInfoParams = {
				methodUrl: "admin/getSettings",
				jsonParam: qs.stringify(salesInfoData)
			};
			this.$axios.postRequest(salesInfoParams).then(
					function (res) {
						//成功之后处理逻辑
						var content = res.data;
						if (content.length != 0) {
							for (var i = 0; i < content.length; i++) {
								that.homeImg = content[i].pic_url;
								that.homeID = content[i].id;
							}
						} else {
							that.homeImg = '';
							that.homeID = '';
							this.$refs.upload.clearFiles();
						}

					},
					function (res) {
						//失败之后处理逻辑
						console.log("error:");
					}
			);
		},
		// //删除首页图
		// deleteHomeImg() {
		//   var userData = qs.parse(sessionStorage.getItem("userData"));
		//   var that = this;

		//   var salesInfoData = {
		//     id: that.homeID
		//   };

		//   var salesInfoParams = {
		//     methodUrl: "admin/delSettings",
		//     jsonParam: qs.stringify(salesInfoData)
		//   };
		//   this.$axios.postRequest(salesInfoParams).then(
		//     function(res) {
		//       //成功之后处理逻辑

		//       that.$message({
		//         showClose: true,
		//         message: "删除成功",
		//         type: "success"
		//       });
		//       that.$refs.upload.clearFiles();
		//       that.findHomePhoto();
		//     },
		//     function(res) {
		//       //失败之后处理逻辑
		//       console.log("error:");
		//     }
		//   );
		// },

		//查看大图
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		//查询景区
		findScenic() {
			var userData = qs.parse(sessionStorage.getItem("userData"));
			var that = this;

			var salesInfoData = {
				count: true,
				orderby: "",
				pageindex: this.currentPage,
				pagesize: 1000
			};

			var salesInfoParams = {
				methodUrl: "admin/getScenicArea",
				jsonParam: qs.stringify(salesInfoData)
			};
			this.$axios.postRequest(salesInfoParams).then(
					function (res) {
						//成功之后处理逻辑
						that.scenicList = res.data.list;

						that.total = res.data.totalcount;
					},
					function (res) {
						//失败之后处理逻辑
						console.log("error:");
					}
			);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/homePageImg.vue